import { NetworkError } from "../api/errors";

/** Upper bound for GET /auth/me so the UI cannot stay on "Проверка сессии…". */
export const AUTH_BOOTSTRAP_TIMEOUT_MS = 8_000;

/**
 * Resolves with `promise`, or rejects with NetworkError if it does not settle
 * in time. Used because some browser/SW fetch paths ignore AbortSignal.
 */
export async function withAuthBootstrapTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number = AUTH_BOOTSTRAP_TIMEOUT_MS,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      promise,
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => {
          reject(new NetworkError());
        }, timeoutMs);
      }),
    ]);
  } finally {
    if (timer !== undefined) {
      clearTimeout(timer);
    }
  }
}
